import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { loadStripe } from '@stripe/stripe-js';
import {
    Elements,
    useStripe,
} from '@stripe/react-stripe-js';
import { toggleNoti, toggleError } from 'config/slice/message'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useGetInvoiceListMutation, useVaddedMutation } from 'config/api/waV1_user';
import { isEmpty } from 'lodash';
import getI18nStatusText from 'utils/formStatus';
import { filters, resp_service_filter, resp_services } from 'config/const/global';
import { useTranslation } from 'react-i18next';
import { KEY_BTN_VAL_ADDED, KEY_COL_AMOUNT, KEY_COL_APPLIER, KEY_COL_STATUS, KEY_COL_UPDATED_AT, KEY_ERROR_VAL_ADDED_FAILED, KEY_LABEL_PAST_RECORD, KEY_LABEL_WALLET_CURRENT_CREDIT, KEY_LABEL_WALLET_OTHER_PAYMENTS, KEY_VALUE_100, KEY_VALUE_1000, KEY_VALUE_200, KEY_VALUE_2000, KEY_VALUE_3000, KEY_VALUE_500, MODULE_WALLET } from 'config/const/locale';




function createData(id, applier, amount, update_at, status) {
    return { id, applier, amount, update_at, status };
}

let rows = [
];


export default function Wallet() {

    const { t } = useTranslation(MODULE_WALLET)

    const columns = [
        { id: 'id', label: 'id', minWidth: 20 },
        // { id: 'name', label: '公司名稱', minWidth: 100 },
        {
            id: 'applier',
            label: t(KEY_COL_APPLIER),
            minWidth: 100,
            align: 'right',
        },
        {
            id: 'amount',
            label: t(KEY_COL_AMOUNT),
            minWidth: 100,
            align: 'right',
            format: (value) => value.toLocaleString('en-US'),
        },
        {
            id: 'update_at',
            label: t(KEY_COL_UPDATED_AT),
            minWidth: 100,
            align: 'right',
        },
        {
            id: 'status',
            label: t(KEY_COL_STATUS),
            minWidth: 100,
            align: 'right',
        },
    ];

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [newRows, setNewRows] = React.useState([]);
    const [amount, setAmount] = React.useState('')
    const dispatch = useDispatch()
    const [vaddedFn] = useVaddedMutation()
    const [getInvFn] = useGetInvoiceListMutation()

    const stripe = useStripe()

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleAmountToSid = (amt) => {
        switch (amt) {
            case '100':
                return { id: resp_services?.value?.value?.filter(i => i?.name == resp_service_filter?.value?.value?.recharge?.fixed_amount?.hkd100)[0]?.id, quantity: 1 }
            case '200':
                return { id: resp_services?.value?.value?.filter(i => i?.name == resp_service_filter?.value?.value?.recharge?.fixed_amount?.hkd200)[0]?.id, quantity: 1 }
            case '500':
                return { id: resp_services?.value?.value?.filter(i => i?.name == resp_service_filter?.value?.value?.recharge?.fixed_amount?.hkd500)[0]?.id, quantity: 1 }
            case '1000':
                return { id: resp_services?.value?.value?.filter(i => i?.name == resp_service_filter?.value?.value?.recharge?.fixed_amount?.hkd1000)[0]?.id, quantity: 1 }
            case '2000':
                return { id: resp_services?.value?.value?.filter(i => i?.name == resp_service_filter?.value?.value?.recharge?.fixed_amount?.hkd2000)[0]?.id, quantity: 1 }
            case '3000':
                return { id: resp_services?.value?.value?.filter(i => i?.name == resp_service_filter?.value?.value?.recharge?.fixed_amount?.hkd3000)[0]?.id, quantity: 1 }

            default:
                return { id: resp_services?.value?.value?.filter(i => i?.name == resp_service_filter?.value?.value?.recharge?.fixed_amount?.hkd100)[0]?.id, quantity: 1 }
        }
    }

    const handlerIptAmount = (e) => {
        // if (Number(e.target.value) > 0)
        setAmount(e.target.value)
    }

    const handlePriceBtn = (e) => {
        setAmount(e.target.value)
    }

    const handleSubmit = () => {

        // let temp = createData('xxx公司', '當前用户', amount, '成功')

        // if (amount <= 0) {
        //     setNewRows(p => [...p, createData('xxx公司', '當前用户', amount, '失敗')])
        //     dispatch(toggleError({
        //         indicator: true,
        //         msg: '增值失敗'
        //     }))
        // } else {
        //     setNewRows(p => [...p, temp])
        //     dispatch(toggleNoti({
        //         indicator: true,
        //         msg: '增值成功'
        //     }))
        // }

        vaddedFn(handleAmountToSid(amount))
            .then(
                res => {
                    stripe.redirectToCheckout({
                        sessionId: res.data.data.invoice.checkoutSession.id
                    })
                }
            )
            .catch(
                reason => dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_VAL_ADDED_FAILED)
                }))
            )


    }

    useEffect(() => {
        getInvFn(filters.recharge)
            .then(
                res => {
                    if (res.data?.data) {
                        setNewRows(new Array(...(res.data?.data?.invoices?.data)).map(
                            i =>
                                createData(i?.id, i?.user?.name, i?.total, i?.updated_at, i?.payments[0]?.status)
                        ))
                    }
                }
            )
    }, [])


    return (
        <Box sx={{ width: '80%', m: '0 auto', backgroundColor: 'white', borderRadius: 5, p: 2 }}>
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item lg={4}>
                    <Stack direction='row' alignItems='center' justifyContent='center' sx={{ height: '100%' }} >
                        <Typography variant='h6'>{t(KEY_LABEL_WALLET_CURRENT_CREDIT)}</Typography>
                        <TextField type='number' value={amount} onChange={handlerIptAmount} inputProps={{ readOnly: true }} ></TextField>
                    </Stack>
                </Grid>
                <Grid item lg={3}>
                    <Stack direction='column' rowGap={1}>
                        <Grid container spacing={2} >
                            <Grid item lg={4}><Button variant="outlined" value={'100'} onClick={handlePriceBtn}>{t(KEY_VALUE_100)}</Button></Grid>
                            <Grid item lg={4}><Button variant="outlined" value={'200'} onClick={handlePriceBtn}>{t(KEY_VALUE_200)}</Button></Grid>
                            <Grid item lg={4}><Button variant="outlined" value={'500'} onClick={handlePriceBtn}>{t(KEY_VALUE_500)}</Button></Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item lg={4}><Button variant="outlined" value={'1000'} onClick={handlePriceBtn}>{t(KEY_VALUE_1000)}</Button></Grid>
                            <Grid item lg={4}><Button variant="outlined" value={'2000'} onClick={handlePriceBtn}>{t(KEY_VALUE_2000)}</Button></Grid>
                            <Grid item lg={4}><Button variant="outlined" value={'3000'} onClick={handlePriceBtn}>{t(KEY_VALUE_3000)}</Button></Grid>
                        </Grid>
                    </Stack>
                </Grid>
                <Grid item lg={2}>
                    <Stack direction='row' alignItems='center' justifyContent='center' sx={{ height: '100%' }} >
                        <Button variant='contained' onClick={handleSubmit} ><Typography variant='h6'>{t(KEY_BTN_VAL_ADDED)}</Typography></Button>
                    </Stack>
                </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item lg={5}>
                    <Stack direction='row' alignItems='center' justifyContent='center' sx={{ height: '100%' }} >
                        <Typography variant='h6'>{t(KEY_LABEL_WALLET_OTHER_PAYMENTS)}</Typography>
                    </Stack>
                </Grid>
                <Grid item lg={5}>
                    <img src="fps.jpeg" alt="fps" style={{ "maxWidth": "81px", "maxHeight": "81px" }} />
                </Grid>
            </Grid>

            <hr />
            <Typography variant='h5'>{t(KEY_LABEL_PAST_RECORD)}</Typography>
            <Paper sx={{ width: '100%' }}>
                <TableContainer sx={{ maxHeight: 1080 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ top: 0, minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {newRows
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row) => {
                                    return (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                            {columns.map((column) => {
                                                const value = row[column.id];
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {
                                                            column.format && typeof value === 'number'
                                                                ? column.format(value)
                                                                : column.id === 'status'
                                                                    ? getI18nStatusText(value)
                                                                    : value
                                                        }
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={newRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
    )
}
